const version = {
    name: '0.2.1',
    commit: 'b28c0221',
    domain: 'esptool.spacehuhn.com',
}

export default version
